import { Component, OnInit }    from '@angular/core';
import { Platform }             from 'ionic-angular';
import { StatusBar }            from '@ionic-native/status-bar';
import { SplashScreen }         from '@ionic-native/splash-screen';
import { RecentBooksComponent } from "../components/books/recent-books.component";

@Component({
  selector: 'dra-app',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  public rootPage = RecentBooksComponent;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen
  ) {
  }
  public async ngOnInit() {
    await this.platform.ready();
    this.statusBar.overlaysWebView(false);
    this.statusBar.styleLightContent();
    this.statusBar.backgroundColorByHexString('#222');
    this.splashScreen.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts